export const jumpTo = (id) => {
    const target = document.getElementById(id);
    target.scrollIntoView({behavior: "smooth"});
    console.log(id);
  }
